import { render, staticRenderFns } from "./CookieAcceptModal.vue?vue&type=template&id=312479b8&scoped=true"
import script from "./CookieAcceptModal.vue?vue&type=script&lang=js"
export * from "./CookieAcceptModal.vue?vue&type=script&lang=js"
import style0 from "./CookieAcceptModal.vue?vue&type=style&index=0&id=312479b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "312479b8",
  null
  
)

export default component.exports